import { render, staticRenderFns } from "./CultureAssetPurchaseAudit.vue?vue&type=template&id=6c4efe8c&scoped=true&"
import script from "./CultureAssetPurchaseAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAssetPurchaseAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4efe8c",
  null
  
)

export default component.exports